export const CS_CHAT_DEVICE_ID_STORAGE_KEY = 'robojastip:cs-chat-device-id'

/**
 * Returns the persistent device ID for CS chat session minting.
 * Generates and stores a unique guest UUID key if none exists.
 */
export function getOrCreateDeviceId(): string {
  if (typeof window === 'undefined' || !window.localStorage) {
    return `guest-${crypto.randomUUID()}`
  }

  try {
    const existing = window.localStorage.getItem(CS_CHAT_DEVICE_ID_STORAGE_KEY)?.trim()
    if (existing) {
      return existing
    }

    const generated = `guest-${crypto.randomUUID()}`
    window.localStorage.setItem(CS_CHAT_DEVICE_ID_STORAGE_KEY, generated)
    return generated
  } catch {
    return `guest-${crypto.randomUUID()}`
  }
}
